import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  Box,
  IconButton,
  Tooltip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  Grid,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  Autorenew,
  Edit
} from '@mui/icons-material';
import PropTypes from 'prop-types';
import Page from 'src/components/Page';
import renderCellExpand from 'src/views/commons/RenderCellExpand';
import combosService from 'src/services/combosService';
import authService from 'src/services/auth.service';
import userService from 'src/services/usuariosService';
import DataTable from 'src/views/commons/DataTable';
// import ConfirmationDialog from 'src/views/commons/ConfirmationDialog';
import clsx from 'clsx';
import DialogForms from 'src/views/commons/DialogForms';
import AltaUsuario from './AltaUsuario';
import UsuariosToolBar from './UsuariosToolBar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  customHoverFocus: {
    '&:hover': { color: '#fff', backgroundColor: '#4caf50' }
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#4caf50',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath"
        + " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 "
        + "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#4caf50',
    },
  },
}));

const Usuario = ({
  setOpenBackDrop, comboRoles, setComboRoles,
  setServerError, setOpenSnackError,
  setServerMessage, setOpenSnackSuccess,
  nombreUsuario, ...props
}) => {
  const [openAlta, setOpenAlta] = useState(false);
  const [rowsUsers, setRowsUsers] = useState([]);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [formData, setFormData] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [idUsuario, setIdUsuario] = useState(0);
  const [comboClientes, setComboClientes] = useState([]);
  const [passwordAdmin, setPasswordAdmin] = useState(false);
  const classes = useStyles();
  const formName = 'formUsuario';
  const usuarioRef = useRef();

  const handleUsuariosRef = () => {
    usuarioRef.current.resetUsuariosForm();
  };

  useEffect(() => {
    const getComboRoles = async () => {
      const newRoles = [];
      setOpenBackDrop(true);
      if (comboRoles.length === 0) {
        await authService.roles().then((res) => {
          res.data.forEach((val) => {
            const rolTemp = { value: val.rolEnum, text: val.descripcion };
            newRoles.push(rolTemp);
          });
          setComboRoles(newRoles);
        }).catch((error) => {
          setOpenBackDrop(false);
          console.log(`'Error al cargar el combo de roles: '${error}`);
        });
      }
      await combosService.comboClientes().then((resp) => {
        setComboClientes(resp);
      }).catch((error) => {
        setOpenBackDrop(false);
        console.log(`'Error al cargar el combo de clientes: '${error}`);
      });
      setOpenBackDrop(false);
    };
    getComboRoles();
  }, []);
  const onClickEdit = (paramRow) => {
    setFormData(paramRow);
    setOpenAlta(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRows([]);
    setPasswordAdmin(false);
  };
  const onClickUpdatePw = () => {
    const awaitUpdatePw = async () => {
      setOpenBackDrop(true);
      await userService.resetPassword(selectedRows[0], passwordAdmin).then((resp) => {
        if (resp.data != null && resp.data.errorCode === 204) {
          setOpenSnackError(true);
          setServerError(resp.data.mensaje);
        } else {
          setOpenSnackSuccess(true);
          setServerMessage(resp.data.mensaje);
        }
      }).catch((error) => {
        setOpenBackDrop(false);
        if (error.response) {
          setServerError(error.response.data.message);
        } else {
          setServerError(`${error.message}: No fue posible conectar con el servidor`);
        }
        setOpenSnackError(true);
      });
      setOpenBackDrop(false);
    };
    awaitUpdatePw();
    handleCloseDialog();
  };
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      maxWidth: 90,
      minWidth: 90,
      headerClassName: 'header-datagrid'
    },
    {
      field: 'nombreUsuario',
      headerName: 'Usuario',
      minWidth: 120,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: 'nombre',
      headerName: 'Nombre',
      minWidth: 120,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: 'rolDesc',
      headerName: 'Rol',
      minWidth: 100,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: 'nombreCliente',
      headerName: 'Cliente',
      minWidth: 100,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: 'fechaCreacion',
      headerName: 'Creación',
      minWidth: 120,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: 'email',
      headerName: 'E-mail',
      minWidth: 120,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: 'acciones',
      headerName: 'Acciones',
      maxWidth: 100,
      minWidth: 100,
      sortable: false,
      disableClickEventBubbling: true,
      align: 'center',
      renderCell: (params) => {
        const onClick = () => {
          console.log(params.row);
          onClickEdit(params.row);
        };
        const updatePassword = () => {
          setOpenDialog(true);
          setSelectedRows([params.row.id]);
        };
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%'
            }}
          >
            <Tooltip title="Editar">
              <IconButton
                className={classes.customHoverFocus}
                onClick={onClick}
                fontSize="small"
                color="primary"
                size="large"
              >
                <Edit fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reset Password">
              <IconButton
                className={classes.customHoverFocus}
                onClick={updatePassword}
                fontSize="small"
                color="primary"
                size="large"
              >
                <Autorenew fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    }
  ];

  return (
    <Page
      className={classes.root}
      title="Busqueda de Usuarios"
    >
      <Container maxWidth="lg">
        <UsuariosToolBar
          setOpenAlta={setOpenAlta}
          setRowsUsers={setRowsUsers}
          rowsUsers={rowsUsers}
          setOpenBackDrop={setOpenBackDrop}
          setLoading={setLoadingUsuarios}
          selectedRows={selectedRows}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          setServerError={setServerError}
          setServerMessage={setServerMessage}
          preloadedValues={comboRoles}
          setSelectedRows={setSelectedRows}
          {...props}
        />
        <Box sx={{
          mt: 3
        }}
        />
        <DataTable
          rows={rowsUsers}
          columns={columns}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          nombreUsuario={nombreUsuario}
          activateCheckBox
          loading={loadingUsuarios}
        />
        <DialogForms
          setOpenDialog={setOpenAlta}
          openDialog={openAlta}
          submitButtonName={idUsuario === 0 ? 'GUARDAR' : 'ACTUALIZAR'}
          actionButtonName={idUsuario === 0 ? 'LIMPIAR' : undefined}
          titulo={idUsuario === 0 ? 'Alta de Usuario' : 'Editar Usuario'}
          formName={formName}
          handleRef={handleUsuariosRef}
          size="md"
        >
          <AltaUsuario
            ref={usuarioRef}
            preloadedValues={comboRoles}
            formData={formData}
            setFormData={setFormData}
            setOpenBackDrop={setOpenBackDrop}
            setServerError={setServerError}
            setOpenSnackError={setOpenSnackError}
            rowsUsers={rowsUsers}
            idUsuario={idUsuario}
            setIdUsuario={setIdUsuario}
            formName={formName}
            comboClientes={comboClientes}
            setOpenDialog={setOpenAlta}
          />
        </DialogForms>
        <Dialog
          disableEscapeKeyDown
          aria-labelledby="confirmation-dialog-title"
          open={openDialog}
        >
          <DialogTitle id="confirmation-dialog-title">Actualizar contraseña</DialogTitle>
          <DialogContent dividers>
            <Grid>
              Seguro que desea actualizar la contraseña?
            </Grid>
            <Grid align="center">
              <FormControlLabel
                label={<Typography variant="body2">Enviar correo al administrador</Typography>}
                control={(
                  <Checkbox
                    disableRipple
                    checked={passwordAdmin}
                    color="default"
                    checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                    icon={<span className={classes.icon} />}
                    slotProps={{ input: { 'aria-label': 'decorative checkbox' } }}
                    onChange={(event, newValue) => {
                      setPasswordAdmin(newValue);
                    }}
                    tabIndex="-1"
                  />
                )}
                labelPlacement="end"
              />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCloseDialog} color="primary">
              Cancelar
            </Button>
            <Button onClick={onClickUpdatePw} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        {/* <ConfirmationDialog
          keepMounted
          open={openDialog}
          onClose={handleCloseDialog}
          confirm={onClickUpdatePw}
          title="Actualizar contraseña"
          message="Seguro que desea actualizar la contraseña?"
        /> */}
      </Container>
    </Page>
  );
};

Usuario.propTypes = {
  setOpenBackDrop: PropTypes.func,
  comboRoles: PropTypes.array,
  setComboRoles: PropTypes.func,
  setServerError: PropTypes.func,
  setOpenSnackError: PropTypes.func,
  setServerMessage: PropTypes.func,
  setOpenSnackSuccess: PropTypes.func,
  nombreUsuario: PropTypes.string
};

export default Usuario;
